<template>
  <div class="full-container" style="margin-top: 70px">
    <div class="recommend container">
      <el-carousel height="400px" arrow="never">
        <el-carousel-item v-for="(item, index) in rcommond.slice(0,5)"  :key="index">
          <div class="cover"  @click="toNewDetial(item.id)">
            <el-image fit="cover" :src="item.cover"></el-image>
          </div>
          <div class="info" >
            <div class="time pi-fz-20">{{ item.time }}</div>
            <div class="title" @click="toNewDetial(item.id)">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="news container">
      <div class="list">
        <div
          class="wrapper"
          v-for="(item, index) in news.slice((queryParams.page-1)*queryParams.size,(queryParams.page)*queryParams.size)"

          :key="index"
        >
          <!-- <div class="item"> -->
          <div class="cover">
            <el-image :src="item.cover" fit="cover"></el-image>
          </div>
          <div class="info">
            <div class="title">{{ item.title }}</div>
            <div class="time">{{ item.time }}</div>
            <div class="desc">{{ item.desc }}</div>
            <div class="more" @click="toNewDetial(item.id)">
              <div class="">阅读更多</div>
              <i class="iconfont iconweibiaoti40"></i>
            </div>
          </div>
          <!-- </div> -->
        </div>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="queryParams.size"
        prev-text="上一页"
        next-text="下一页"
        :total="total"
        @current-change="currentChange"	
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import newDate from "./news";
export default {
  name: "product",
  data() {
    return {
      rcommond: [],
      news: [],
      // 查询参数
      queryParams: {
        page: 1,
        size: 5,
      },
      total: 0,
    };
  },
  mounted() {},
  created() {
    this.loadNew();
    this.loadRecommend();
  },
  methods: {
    getList() {},
    loadNew() {
      this.news = newDate.filter((value) => {
        return value.recommend.toString() == "false";
      });
      this.total = this.news.length
    },
    loadRecommend() {
      this.rcommond = newDate.filter((value) => {
        return value.recommend.toString() == "true";
      });
    },
    toNewDetial(newId) {
      let url = `/aboutus/news/detail?id=${newId}`;
      this.$router.push({ path: url });
    },
    currentChange(page){
      this.queryParams.page = page
    }
  },
};
</script>


</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/theme.scss";

div {
  width: 100%;
}

/** page style */
.recommend
  ::v-deep
  .el-carousel
  .el-carousel__indicators.el-carousel__indicators--horizontal {
  // transform: translateX(50%);
  // transform: translateX(50%);
  left: calc(50% + 150px);
  padding-bottom: 10px;
}
.recommend ::v-deep .el-carousel__button {
  height: 10px;
  width: 40px;
  background-color: #ddd !important;
}

.recommend ::v-deep .el-carousel__indicator.is-active button {
  background-color: $color-bg-primary !important;
  width: 40px;
}

.recommend

.news ::v-deep .btn-prev,
.news ::v-deep .btn-next {
  padding-left: 10px;
  padding-right: 10px;
}
.recommend {
  margin-bottom: 20px;
  .title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
  }
  .el-carousel__item {
    display: flex;
    .cover {
      cursor: pointer;
      margin-left: 2px;
      width: calc(50% - 2px);
      height: 100%;
      > div {
        height: 100%;
      }
    }
    .info {
      width: 50%;
      background-color: #f5f5f5;
      padding: 73px 71px;
      
      > div {
        text-align: left;
        line-height: 2em;
      }

      .time {
        color: $color-text-primary;
      }
      .title {
        margin-bottom: 20px;
        cursor: pointer;
      }
    }
  }
}
.news {
  .title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
  }
  .list {
    .wrapper {
      display: flex;
      padding: 40px 40px 40px 0;
      border-bottom: 1px solid #e5e5e5;

      .cover {
        width: 400px;
        height: 240px;
        margin-right: 40px;
        .el-image {
          width: 100%;
          height: 100%;
        } 
      }
      .info {
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        > * {
          text-align: left;
        }
        .title {
          line-height: 3em;
        }
        .time {
          font-size: 14px;
          color: #999;
          line-height: 2em;
        }
        .desc {
          line-height: 1.5em;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          height: 3em;
          overflow: hidden;
        }
        .more {
          display: flex;
          width: 160px;
          height: 40px;
          border: 1px solid $color-border-primary;
          justify-content: center;
          align-items: center;
          padding: 10px 30px;
          margin-top: 30px;
          cursor: pointer;

          &:hover {
            background-color: $color-bg-primary;
            > * {
              color: $color-text-white;
            }
          }
        }
      }
    }
  }

  .el-pagination {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/aboutus/news/index.vue